import { langStore } from "@/stores/lang-store"

const LANGS = [
  { code: "ko", label: "한국어" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" }
]

const LangSwitch = () => {
  const { lang, setLang } = langStore()

  return (
    <div
      className="grid grid-cols-3 gap-1 rounded-xl bg-slate-100 p-1"
      role="group"
      aria-label="Language"
    >
      {LANGS.map(({ code, label }) => {
        const isActive = lang === code

        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-pressed={isActive}
            className={`min-w-0 rounded-lg px-2 py-2.5 text-sm transition-all ${
              isActive
                ? "bg-white font-semibold text-toicos-navy shadow-sm ring-1 ring-slate-200/70"
                : "font-medium text-slate-500 hover:text-slate-800"
            }`}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}

export default LangSwitch
